class ProductSteps extends HTMLElement {
  constructor() {
    super();
    this.bundleVariantsData = JSON.parse(this.querySelector('#bundle-variants-data').innerHTML);
    this.mainProductId = '';
    this.mainVariantId = '';
    this.creamerProductId = '';
    this.creamerVariantId = '';
    this.allProductsData = JSON.parse(this.querySelector('#main-product-step-objects').innerHTML);
    this.addToCartButton = this.querySelector('.product-steps__add-to-cart');
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    this.stepBlocks = this.querySelectorAll('[data-step]');
    this.activeStepElement = this.querySelector('.product-step-item--active');
    this.howManyStepsShowed = 4;

    this.mediaGallery = this.closest('.product')?.querySelector('media-gallery') || null;
    this.mediaGallerySlider = document.querySelector('.media-gallery__slider');
    this.mediaGallerySliderSlides = Array.from(this.mediaGallerySlider.querySelectorAll('.slider__media-item'));

    this.popupGallerySlider = document.querySelector('.product-media-modal__dialog')
    this.popupGallerySlides = Array.from(this.popupGallerySlider.querySelectorAll('.product-media-modal__image'))
  }

  connectedCallback() {
    this.toggleATCButtonState();
    this.updateInitialMediaGallery();
    this.handleSetDefaultValues();
    this.updateLandingImageBenefits(this.activeStepElement)

    this.stepBlocks.forEach(stepBlock => {
      stepBlock.addEventListener('click',  () => {
        this.handleStepBlockClick(stepBlock);
      });
    })

    this.addToCartButton?.addEventListener('click', () => {
      this.addToCart();
    });

    window.addEventListener('DOMContentLoaded', () => {
      this.imageWithTextSectionsDependOnProduct = document.querySelectorAll('[data-attached-product-id]');
      this.showDefaultDependOnProductSections();
    })
  }

  handleSetDefaultValues() {
    const mainProductBlockActive = this.querySelector('[data-step="1"].product-step-item--active');
    const creamerProductBlockActive = this.querySelector('[data-step="3"].product-step-item--active');

    this.updateMainProductId(mainProductBlockActive);
    this.updateMainVariantBlocks();
    this.updateMainVariantId();
    this.updateCreamerProductAndVariantId(creamerProductBlockActive);
  }

  toggleATCButtonState() {
    if (window.subscriptionOptions?.is_sold_out) {
      this.addToCartButton.textContent = window.variantStrings.soldOut;
      this.addToCartButton.disabled = true;
      this.addToCartButton.classList.add('product-form__submit--out-of-stock');
    }
  }

  handleStepBlockClick(stepBlock) {
    const stepNumber = +stepBlock.dataset.step;

    this.updateActiveStep(stepBlock, stepNumber);
    if (stepNumber === this.howManyStepsShowed) {
      this.showNextStep(stepNumber);
    }

    switch (stepNumber) {
      case 1:
        this.updateMainProductId(stepBlock);
        this.updateMainVariantBlocks();
        this.updateMainVariantId();
        this.updateLandingImageBenefits(stepBlock);
        break;
      case 2:
        this.updateMainVariantId();
        break;
      case 3:
        this.updateCreamerProductAndVariantId(stepBlock);
        break;
    }

    this.updateMediaGallery(this.mediaGallerySlider, this.mediaGallerySliderSlides);
    //this.updateMediaGallery(this.popupGallerySlider, this.popupGallerySlides)
    this.showDependOnProductSections();
  }

  updateLandingImageBenefits(stepBlock) {
    const landingImageBenefitsSection = document.querySelector('.landing-image-benefits__wrapper--dynamic');
    const productMainId = stepBlock.dataset.mainProductId

    if(!landingImageBenefitsSection) return

    const script = document.getElementById('landing-image-benefits');
    if (!script) return 
          
    const dataDynamicImages = JSON.parse(script.textContent);
    const imageContainer = document.querySelector('.landing-image-benefits__image-container');
    const image = imageContainer.querySelector('img');
    const match = image.src.match(/^(.*\/files\/)/);
     dataDynamicImages.forEach(item => {
      if(Number(item.product_id) === Number(productMainId)) {
        const newImg = document.createElement('img');
        newImg.src = `${match[1]}${item.image_handle}.webp`;
        newImg.alt = '';
        newImg.loading = 'lazy';
        newImg.width = image.width;
        newImg.height = image.height;

        imageContainer.innerHTML = ''; 
        imageContainer.appendChild(newImg);
      }
    })
  }

  showNextStep(stepNumber) {
    const nextStepContainer = this.querySelector(`[data-step-container="${stepNumber + 1}"]`);
    if (!nextStepContainer) return;

    // Use constant 72 for adding double line-height if product title too long and wraps in 2 or 3 line;
    nextStepContainer.style.maxHeight = (nextStepContainer?.scrollHeight + 72) + 'px';
    nextStepContainer?.classList.add('product-step--visible');
    this.howManyStepsShowed++;
  }

  updateActiveStep(stepBlock, stepNumber) {
    const currentActiveStepBlock = this.querySelector(`.product-step-item--active[data-step="${stepNumber}"]`);
    if (stepBlock == currentActiveStepBlock) return;

    currentActiveStepBlock?.classList.remove('product-step-item--active');
    stepBlock?.classList.add('product-step-item--active');
  }

  updateMainProductId(stepBlock) {
    this.mainProductId = stepBlock.dataset.mainProductId;
  }

  updateMainVariantBlocks() {
    const mainVariantBlocks = this.querySelectorAll('[data-step="2"]');
    const selectedProductData = this.allProductsData[this.mainProductId];

    mainVariantBlocks.forEach(mainVariantBlock => {
      const currentVariant = selectedProductData.variants.find(variant => {
        return variant.option1 == mainVariantBlock.dataset.optionTitle;
      })

      currentVariant ? mainVariantBlock.setAttribute('data-main-variant-id', currentVariant.id) : mainVariantBlock.setAttribute('data-main-variant-id', 'unavailable');
    })
  }

  updateMainVariantId() {
    const selectedVariantBlock = this.querySelector('[data-step="2"].product-step-item--active')
    if (!selectedVariantBlock) return;
    this.mainVariantId = selectedVariantBlock.dataset.mainVariantId;
  }

  updateCreamerProductAndVariantId(stepBlock) {
    this.creamerProductId = stepBlock.dataset.creamerProductId;
    this.creamerVariantId = stepBlock.dataset.creamerVariantId;
  }

  updateInitialMediaGallery() {
    const allSlides = this.mediaGallerySlider?.querySelectorAll('.slider__media-item');
    allSlides?.forEach(slide => {
      if (!slide.classList.contains('slider__media-item--active')) {
        slide.remove();
      }
    })

    let waitInitSwiperInterval = setInterval(() => {
      if (this.mediaGallerySlider.swiper) {
        this.mediaGallerySlider.swiper.update();
        clearInterval(waitInitSwiperInterval);
      }
    }, 300);
  }

  updateMediaGallery(mediaSlider, slides) {
    const mediaGallerySliderWrapper = mediaSlider?.querySelector('.swiper-wrapper')
    const oldBundleImage = mediaGallerySliderWrapper?.querySelector('.slider__media-item--steps-bundle');
    const oldRoastImage = mediaGallerySliderWrapper?.querySelector('.slider__media-item--steps-roast');
    let newBundleImage = slides.find(slide => {
      return slide.dataset.mainProductId == this.mainProductId && slide.classList.contains('slider__media-item--steps-bundle')
    });
    let newRoastImage = slides.find(slide => {
      return slide.dataset.mainProductId == this.mainProductId && slide.classList.contains('slider__media-item--steps-roast')
    });

    this.replaceMediaGallerySlide(newRoastImage, oldRoastImage, 1, mediaGallerySliderWrapper);

    if (this.creamerProductId) {
      const oldCreamerImages = mediaGallerySliderWrapper?.querySelectorAll('.slider__media-item--steps-creamer');
      newBundleImage = slides.find(slide => {
        return slide.dataset.mainProductId == this.mainProductId &&
              slide.dataset.creamerProductId == this.creamerProductId &&
              slide.classList.contains('slider__media-item--steps-bundle');
      });
      let newCreamerImages = slides.filter(slide => {
        return slide.dataset.creamerProductId == this.creamerProductId && slide.classList.contains('slider__media-item--steps-creamer')
      });

      this.replaceMediaGallerySlide(newBundleImage, oldBundleImage, 0, mediaGallerySliderWrapper);

      for (let index = 0; index < newCreamerImages.length; index++) {
        const oldCreamerImage = oldCreamerImages[index];
        const newCreamerImage = newCreamerImages[index];
        const imagePosition = index + 2;

        this.replaceMediaGallerySlide(newCreamerImage, oldCreamerImage, imagePosition, mediaGallerySliderWrapper);
      }
    } else {
      this.replaceMediaGallerySlide(newBundleImage, oldBundleImage, 0, mediaGallerySliderWrapper);
    }

    mediaSlider.swiper.update();
    this.mediaGallery?.updateSlidesSwipeabillity();
  }

  replaceMediaGallerySlide(newSlide, oldSlide, index, parentElement) {
    if (!oldSlide && newSlide) {
      parentElement.append(newSlide);
      newSlide.setAttribute('data-swiper-slide-index', index);
      return;
    }

    if(!newSlide && oldSlide) {
      oldSlide.remove();
      return;
    }

    if (newSlide && newSlide != oldSlide) {
      parentElement?.replaceChild(newSlide, oldSlide);
      newSlide.setAttribute('data-swiper-slide-index', index);
    }
  }

  clearCart() {
    return fetch('/cart/clear.js')
  }

  addToCart() {
    const bundleVariantId = this.getBundleVariantIdForAddToCart();
    if (!bundleVariantId) return;

    document.dispatchEvent(new Event('theme:loading:start'))

    const additionalProductIds = this.getBundleAdditionalProducts();
    const additionalProductsString = additionalProductIds.length ?
      ',' + additionalProductIds.map(id => id + ':1').join(',') :
      '';

    const data = {
      'items': [
        {
          'id': Number(bundleVariantId),
          'quantity': 1,
          'properties': {
            _bundleComponents: `${this.mainVariantId}:2,${this.creamerVariantId}:1${additionalProductsString}`
          }
        }
      ],
      sections: this.cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    };

    if(localStorage.getItem('first-visited-page')){
      data.items[0].properties = data.items[0].properties || {};
      data.items[0].properties['_first_visited_page'] = localStorage.getItem('first-visited-page');
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then((response) => response.json())
    .then((response) => {
      this.cart.renderContents(response);
    })
    .catch((error) => {
      console.error('Error:', error);
    })
    .finally(() => {
      if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      document.dispatchEvent(new Event('theme:loading:end'));
    });
  }

  getBundleVariantIdForAddToCart() {
    for (const key in this.bundleVariantsData) {
      const variant = this.bundleVariantsData[key];
      if (variant.mainProductId.includes(+this.mainVariantId) && variant.creamerProductId.includes(+this.creamerVariantId)) {
        return key;
      }
    }

    return false
  }

  getBundleAdditionalProducts() {
     for (const key in this.bundleVariantsData) {
      const variant = this.bundleVariantsData[key];
      if (variant.mainProductId.includes(+this.mainVariantId) && variant.creamerProductId.includes(+this.creamerVariantId)) {
        return variant.additionalProductIds;
      }
    }

    return [];
  }

  showDefaultDependOnProductSections() {
    this.imageWithTextSectionsDependOnProduct.forEach(section => {
      if (section.dataset.isShowDefault === "true") {
        section.style.display = 'block';
      } else {
        section.style.display = 'none';
      }
    })
  }

  showDependOnProductSections() {
    this.imageWithTextSectionsDependOnProduct.forEach(section => {
      const sectionProductId = section.dataset.attachedProductId;
      if (sectionProductId === this.mainProductId) {
        section.style.display = 'block';
      } else {
        section.style.display = 'none';
      }
    })
  }
}

if (!customElements.get('product-steps')) {
  customElements.define('product-steps', ProductSteps);
}